import { PortalServicePortalExtendedDto } from '@nimbus/portal-service/lib/client/api';
import { axiosClient } from '@nx-frontend/shared/api';
import { assertServiceHost } from '@nx-frontend/shared/api/services/util';

export type GetPortalInfoProps = { host: string; superSecret: string; workspaceId: string; portalId: string };

export async function getPortalInfo({
  host,
  workspaceId,
  portalId,
  superSecret,
}: GetPortalInfoProps): Promise<PortalServicePortalExtendedDto> {
  const response = await axiosClient.get<PortalServicePortalExtendedDto>(
    `${assertServiceHost(host)}/v1/workspaces/${workspaceId}/portals/${portalId}`,
    {
      secret: superSecret,
    }
  );

  return response.data;
}
